import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import LandingPage from "./pages/LandingPage";
import SignInPage from "./pages/SignInPage";
import HomePage from "./pages/HomePage";
import GamePage from "./pages/GamePage";
import TutorialPage from "./pages/TutorialPage";
import AboutPage from "./pages/AboutPage";
import FundAccountPage from "./pages/FundAccountPage";
import ProfilePage from "./pages/ProfilePage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import AIStatsPage from "./pages/AIStatsPage";
import AdminPage from "./pages/AdminPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import CommunityPlayPage from "./pages/CommunityPlayPage";
import AISimulationPage from "./pages/AISimulationPage";
import BackgroundLabPage from "./pages/BackgroundLabPage";
import LeaderboardPage from "./pages/LeaderboardPage";
import TournamentsPage from "./pages/TournamentsPage";
import ReferralPage from "./pages/ReferralPage";
import ClubsPage from "./pages/ClubsPage";
import ClubDetailPage from "./pages/ClubDetailPage";
import SeasonsPage from "./pages/SeasonsPage";
import FriendsPage from "./pages/FriendsPage";
import ShopPage from "./pages/ShopPage";
import MembershipPage from "./pages/MembershipPage";
import LivePlayPage from "./pages/LivePlayPage";
import OnboardingPage from "./pages/OnboardingPage";
import FairnessPage from "./pages/FairnessPage";
import LeaderPage from "./pages/LeaderPage";
import GameViewerPage from "./pages/GameViewerPage";
import RegionalChatPage from "./pages/RegionalChatPage";
import BuckEuchreRulesPage from "./pages/BuckEuchreRulesPage";
import BuckEuchreStrategyPage from "./pages/BuckEuchreStrategyPage";
import EuchreRulesPage from "./pages/EuchreRulesPage";
import EuchreStrategyPage from "./pages/EuchreStrategyPage";
import EuchreVariationsPage from "./pages/EuchreVariationsPage";
import EuchrePage from "./pages/EuchrePage";
import "./App.css";

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<LandingPage />} />
            <Route path="signin" element={<SignInPage />} />
            <Route path="home" element={<HomePage />} />
            <Route path="play" element={<ProtectedRoute><GamePage /></ProtectedRoute>} />
            <Route path="tutorial" element={<TutorialPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="fund" element={<ProtectedRoute><FundAccountPage /></ProtectedRoute>} />
            <Route path="profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            <Route path="verify" element={<VerifyEmailPage />} />
            <Route path="ai-stats" element={<ProtectedRoute><AIStatsPage /></ProtectedRoute>} />
            <Route path="analytics" element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
            <Route path="community" element={<ProtectedRoute><CommunityPlayPage /></ProtectedRoute>} />
            <Route path="live-play" element={<ProtectedRoute><LivePlayPage /></ProtectedRoute>} />
            <Route path="admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
            <Route path="ai-simulation" element={<ProtectedRoute><AISimulationPage /></ProtectedRoute>} />
            <Route path="background-lab" element={<ProtectedRoute><BackgroundLabPage /></ProtectedRoute>} />
            <Route path="leaderboards" element={<LeaderboardPage />} />
            <Route path="tournaments" element={<TournamentsPage />} />
            <Route path="referrals" element={<ProtectedRoute><ReferralPage /></ProtectedRoute>} />
            <Route path="clubs" element={<ProtectedRoute><ClubsPage /></ProtectedRoute>} />
            <Route path="clubs/:id" element={<ProtectedRoute><ClubDetailPage /></ProtectedRoute>} />
            <Route path="seasons" element={<SeasonsPage />} />
            <Route path="friends" element={<ProtectedRoute><FriendsPage /></ProtectedRoute>} />
            <Route path="shop" element={<ProtectedRoute><ShopPage /></ProtectedRoute>} />
            <Route path="membership" element={<ProtectedRoute><MembershipPage /></ProtectedRoute>} />
            <Route path="onboarding" element={<ProtectedRoute><OnboardingPage /></ProtectedRoute>} />
            <Route path="fairness" element={<FairnessPage />} />
            <Route path="leaders" element={<LeaderPage />} />
            <Route path="game-viewer" element={<ProtectedRoute><GameViewerPage /></ProtectedRoute>} />
            <Route path="regional-chat" element={<ProtectedRoute><RegionalChatPage /></ProtectedRoute>} />
            <Route path="buck-euchre-rules" element={<BuckEuchreRulesPage />} />
            <Route path="buck-euchre-strategy" element={<BuckEuchreStrategyPage />} />
            <Route path="euchre-rules" element={<EuchreRulesPage />} />
            <Route path="euchre-strategy" element={<EuchreStrategyPage />} />
            <Route path="euchre-variations" element={<EuchreVariationsPage />} />
            <Route path="euchre" element={<ProtectedRoute><EuchrePage /></ProtectedRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
